<template>
  <span v-tooltip="presentationModeTooltip">
    <span
      class="cursor-pointer group"
      @click.stop="switchPrivateMode()"
    >
      <aha-icon-container
        :class="{'transition group-hover:bg-secondary-20 3xs:mr-1': !isCanvasButton,
                 'private-mode__wrapper': isCanvasButton,
                 'light-text': isLightTextTheme}"
        :iconClass="isCanvasButton ?
          (isLightTextTheme ? 'text-base-0' : 'text-base-90') : 'text-secondary-50 bg-secondary-15'"
        clickable
        v-if="presentation.privateMode"
      >
        <aha-spinner
          v-if="presentation.isSwitchingPresentationMode || isCheckingPerm"
          :variant="isCanvasButton ?
            (isLightTextTheme ? 'white' : 'dark') : 'dark'"
        />
        <aha-icon
          v-else
          name="hide"
          :width="isCanvasButton ? 24 : 12"
          :height="isCanvasButton ? 24 : 12"
          viewBox="0 0 24 24"
        />
      </aha-icon-container>
      <aha-icon-container
        class="transition group-hover:bg-secondary-20 3xs:mr-1"
        clickable
        v-if="!presentation.privateMode"
      >
        <aha-spinner v-if="presentation.isSwitchingPresentationMode || isCheckingPerm" />
        <aha-icon
          v-else
          name="unhide"
          width="12"
          height="12"
          viewBox="0 0 24 24"
        />
      </aha-icon-container>

      <span class="inline-block text-xs text-base-80" v-if="!isCanvasButton">
        <span v-if="presentation.privateMode">Private</span>
        <span v-else>Public</span>
      </span>
    </span>
    <ModalPresentingPrivateMode
      v-if="isModalPresentingPrivateModeVisible"
      @hideModal="isModalPresentingPrivateModeVisible = false"
      openFrom="Instruction bar"
    />
  </span>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import configs from '@/config'
import constants from '@/constant'

import ModalPresentingPrivateMode from '@/components-v2/modals/PresentingPrivateMode.vue'

const { gaCategories } = constants

export default {
  components: {
    ModalPresentingPrivateMode,
  },
  props: {
    presentation: {
      type: Object,
      default: null,
    },
    isCanvasButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCheckingPerm: false,
      isModalPresentingPrivateModeVisible: false,
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
      slideActive: (state) => state.slideActive,
    }),
    isLightTextTheme() {
      return this.slideActive.textColour === '#ffffff'
    },
    privateModeTooltip() {
      return 'Private: Audience cannot see or interact with your slides'
    },
    publicModeTooltip() {
      return 'Public: Audience can see and interact with your slides'
    },
    presentationModeTooltip() {
      return this.presentation.privateMode ? this.privateModeTooltip : this.publicModeTooltip
    },
  },
  methods: {
    ...mapActions(['setPresentationsAction']),
    async switchPrivateMode() {
      if (this.isCanvasButton) {
        this.isModalPresentingPrivateModeVisible = true
        return
      }
      this.isCheckingPerm = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isCheckingPerm = false
      if (!hasPerm) return
      let newPresentations = this.presentations.map((item) => {
        if (item.id === this.presentation.id) {
          return { ...item, isSwitchingPresentationMode: true }
        }

        return item
      })
      this.setPresentationsAction(newPresentations)

      const newValue = !this.presentation.privateMode
      const presentationMode = newValue ? 'private' : 'public'

      try {
        await this.$http.put(configs.api.updatePresentation + this.presentation.id, {
          privateMode: newValue,
        })
      } catch (error) {
        utils.showToastError('Changing status failed. Please try again.')

        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, `Presentation > Switch to ${presentationMode} > Failed`)
        throw error
      } finally {
        newPresentations = this.presentations.map((item) => {
          if (item.id === this.presentation.id) {
            return { ...item, isSwitchingPresentationMode: false }
          }

          return item
        })
        this.setPresentationsAction(newPresentations)
      }

      newPresentations = this.presentations.map((item) => {
        if (item.id === this.presentation.id) {
          return { ...item, privateMode: newValue }
        }

        return item
      })
      this.setPresentationsAction(newPresentations)

      utils.showToastSuccess(`Presentation has been switched to ${presentationMode}.`)
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, `Presentation > Switch to ${presentationMode} > Succeeded`)
    },
  },
}
</script>
